import React from "react";
import Navbar from "../Components/Navbar";
import { isMobile } from "react-device-detect";
import SmartAi from "../Components/SmartAi";
import Footer from "../Components/Footer";
import { motion } from "motion/react";
import Core from "../Components/Core";

const Secondary = () => {
  return (
    <div>
      <Navbar />

      {/* HERO SECTION */}
      <section className="bg-white pb-lg-6 pb-4 px-lg-6 px-0">
        <div className="container">
          <div className="row pt-lg-10 pt-6 pb-lg-6 px-lg-0">

            {/* TEXT CONTENT */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0"
            >
              <div className="text-center text-md-start">
                <div className="text-muted text-uppercase mb-2 fs-6">
                  A Comprehensive Approach to Education
                </div>
                <div className="fs-m fw-semibold mb-2 text-dark">
                  Secondary School Program
                </div>
              </div>

              <div
                className={`fs-4 text-dark ${
                  isMobile ? "px-4" : "text-justify"
                }`}
              >
                At Ebun Heritage Schools, our Secondary School Program is
                designed to equip students with the academic strength,
                discipline, and leadership qualities required for success in
                higher education and beyond.
                <br />
                <br />
                We provide a rigorous and engaging curriculum that develops
                critical thinking, problem-solving skills, innovation, and
                intellectual independence.
                <br />
                <br />
                Our educators mentor students to discover their purpose,
                maximize their God-given potential, and prepare confidently for
                national and international opportunities.
              </div>
            </motion.div>

            {/* IMAGE 1 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <img
                src="../../assets/images/background/sec1.png"
                alt="Secondary Program"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>

            {/* IMAGE 2 */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center mt-lg-n16"
            >
              <img
                src="../../assets/images/background/sec2.png"
                alt="Advanced Learning"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>

            {/* OFFER SECTION */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0 mt-lg-8 mt-4"
            >
              <div className="fs-t2 fw-semibold mb-4 text-lg-start text-center">
                <span style={{ color: "#38a169" }}>★</span>{" "}
                We <u className="text-primary"><span className="text-dark-blue">Offer Excellence.</span></u>
              </div>

              <div
                className={`fs-4 text-dark ${
                  isMobile ? "px-4" : "text-justify"
                }`}
              >
                Our secondary curriculum integrates academics, technology,
                leadership development, and character building.
                <br />
                <br />
                Students participate in science innovation, debates,
                entrepreneurship initiatives, leadership programs, and
                extracurricular activities that foster balanced development.
                <br />
                <br />
                We maintain high standards of discipline, moral integrity, and
                academic performance in a safe and supportive environment.
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* WAEC / NECO PREPARATION SECTION */}
      <section className="bg-white py-lg-12 py-6">
        <div className="container">
          <div className="row justify-content-center text-center mb-6">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-8"
            >
              <div className="text-muted text-uppercase mb-2 fs-6">
                Academic Distinction
              </div>
              <h2 className="fw-bold text-dark">
                WAEC & NECO Examination Excellence
              </h2>
              <p className="fs-5 text-muted mt-3">
                At Ebun Heritage Schools, we implement a structured and result-driven
                preparation strategy to ensure outstanding performance in WAEC and NECO examinations.
              </p>
            </motion.div>
          </div>

          <div className="row g-4">
            {[
              "Intensive Revision Programs & Mock Examinations",
              "Past Questions Drills & Examiner-Focused Techniques",
              "Small Group Coaching & Personalized Mentorship",
              "Continuous Assessment & Performance Tracking",
              "Weekend & Holiday Booster Classes",
              "Moral Discipline & Exam Confidence Training"
            ].map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="col-md-6 col-lg-4"
              >
                <div
                  className="card border-0 shadow-sm h-100 p-4 text-center"
                  style={{ borderRadius: "20px" }}
                >
                  <div
                    className="mb-3"
                    style={{
                      fontSize: "30px",
                      color: "#38a169",
                      fontWeight: "bold",
                    }}
                  >
                    ✓
                  </div>
                  <div className="fw-semibold fs-5 text-dark">
                    {item}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="text-center mt-8"
          >
            <p className="fs-5 text-dark">
              Our consistent track record of excellence in national examinations
              reflects our commitment to academic brilliance, discipline, and
              leadership development.
            </p>
          </motion.div>
        </div>
      </section>

      {/* CONTACT + GOAL SECTION */}
      <section className="bg-back pt-lg-6 pt-8 pb-lg-6 pb-4 px-lg-6 px-0">
        <div className="container">

          {/* CONTACT CARD */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="px-lg-18 mt-lg-n20 mt-n8"
          >
            <div
              className="card shadow-lg bg-dark-blue p-4 p-lg-6"
              style={{ borderRadius: "30px" }}
            >
              <div className="d-lg-flex text-center align-items-center justify-content-center">
                <div>
                  <div className="fs-5 text-white">Get In Touch</div>
                  <div className="fs-3 text-white">
                    admin@ebunheritageschools.com
                  </div>
                </div>

                <div className="mx-4">
                  <button className="btn btn-icon btn-white shadow-lg fw-semibold py-4 px-4 fs-5 rounded-circle">
                    OR
                  </button>
                </div>

                <div>
                  <div className="fs-5 text-white">Call Us</div>
                  <div className="fs-3 text-white">
                  +234 906 216 8062
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* GOAL SECTION */}
          <div className="row align-items-center pt-lg-10 pt-6 pb-lg-6 px-lg-0">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6 mb-lg-0"
            >
              <div className="fs-t2 fw-semibold mb-4 text-lg-start text-center">
                <span style={{ color: "#38a169" }}>★</span>{" "}
                Our <u className="text-primary"><span className="text-dark-blue">Goal.</span></u>
              </div>

              <div
                className={`fs-4 text-dark ${
                  isMobile ? "px-4" : "text-justify"
                }`}
              >
                Our goal is to raise disciplined, morally upright, academically
                sound, and spiritually grounded young leaders.
                <br />
                <br />
                At Ebun Heritage Schools, we prepare students not only for
                examinations but for life — equipping them with confidence,
                resilience, global awareness, and leadership competence.
                <br />
                <br />
                We are committed to molding destinies and shaping futures
                through excellence in education.
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <img
                src="../../assets/images/background/value.png"
                alt="Our Goal"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>
          </div>
        </div>
      </section>

      <Core />
      
      <Footer />
    </div>
  );
};

export default Secondary;
